import { useState } from "react";

import { useTitleStore } from "store";
import { UploadTitleDocumentFunction } from "types/functions";
import { BaseAsyncHook } from "types/hooks";

interface UseUploadTitleDocument extends BaseAsyncHook {
  uploadTitleDocument: UploadTitleDocumentFunction;
}

export const useUploadTitleDocument = (): UseUploadTitleDocument => {
  const _stateFunc = useTitleStore((state) => state.uploadTitleDocument);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  const uploadTitleDocument = async (
    ...args: Parameters<UploadTitleDocumentFunction>
  ) => {
    try {
      setIsLoading(true);
      setIsError(false);
      const response = await _stateFunc(args[0]);
      return response;
    } catch (error) {
      setIsError(true);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    error: isError,
    loading: isLoading,
    uploadTitleDocument,
  };
};
